import { BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import LoginPage from './assets/pages/login/login';
import SignUpPage from './assets/pages/signup/signup';
import Dashboard from './assets/pages/dashboard/active/dashboard'
import DashboardError from './assets/pages/dashboard/error/dashboard-error';
import SubscriptionPage from './assets/pages/subscriptions/subscriptions';
import AccountSettingPage from './assets/pages/accountSettings/main';
import ResetPasswordPage from './assets/pages/resetPassword/resetPassword';
import AuthTwoFactorPage from './assets/pages/authTwoFactor/authTwoFactor';

import AccountFriendsLayout from './assets/pages/accountFriends/friends';
import AccountFriendsMainLayout from './assets/pages/accountFriends/components/main';
import AccountFriendsPending from './assets/pages/accountFriends/components/pending-requests';
import AccountFriendsSent from './assets/pages/accountFriends/components/sent-requests';
import AccountActualFriends from './assets/pages/accountFriends/components/actual-friends';

import ClientViewPage from './assets/pages/clientView/clientView';
import ClientViewLoginPage from './assets/pages/clientView/login/login';
import ClientViewAuthTwoFactorPage from './assets/pages/clientView/authTwoFactor/authTwoFactor';

import ChangelogsPage from './assets/pages/changeLogs/changelogs'

import SessionsPage from './assets/pages/sessions/sessionsPage'

import LegalsLayout from './assets/pages/legals/legals'
import CookiePolicyMain from './assets/pages/legals/cookie-policy/cookiePolicy'
import PrivacyPolicyMain from './assets/pages/legals/privacy/privacyPolicy'
import TermsOfServiceMain from './assets/pages/legals/terms-of-service/termsOfService'

import LandingPage from './assets/pages/landingPage/landingPage';


import './App.css';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard-error" element={<DashboardError />} />
        <Route path="/subscription-plans" element={<SubscriptionPage />} />
        <Route path="/account-settings" element={<AccountSettingPage />} />
        <Route path="/client-view" element={<ClientViewPage />} />
        <Route path="/client-view/login" element={<ClientViewLoginPage />} />
        <Route path="/client-view/two-factor-auth" element={<ClientViewAuthTwoFactorPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/two-factor-auth" element={<AuthTwoFactorPage />} />
        <Route path="/software-changelogs" element={<ChangelogsPage />} />
        <Route path="/sessions" element={<SessionsPage />} />

        <Route element={<AccountFriendsLayout />}>
          <Route path="/friends" element={<AccountFriendsMainLayout />}>
            <Route index element={<Navigate to="/friends/pending-requests" replace />} />

            <Route path="pending-requests" element={<AccountFriendsPending />} />
            <Route path="sent-requests" element={<AccountFriendsSent />} />
            <Route path="current-friends" element={<AccountActualFriends />} />
          </Route>
        </Route>

        <Route path="/legals" element={<LegalsLayout />}>
          <Route index element={<Navigate to="/legals/privacy-policy" replace />} />

          <Route path="cookie-policy" element={<CookiePolicyMain />} />
          <Route path="privacy-policy" element={<PrivacyPolicyMain />} />
          <Route path="terms-of-service" element={<TermsOfServiceMain />} />
        </Route>

        <Route path="/*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
